import { CallsAndPuts } from '@benzinga/data-option-chain';
import { format } from 'date-fns';
import { useCallback } from 'react';
import styles from './TableRow.module.scss';

interface TableRowProps {
  className?: string;
  values?: CallsAndPuts;
}

const TableRow = ({ className, values }: TableRowProps) => {
  const formatNumber = useCallback((value: number, isPercentage = false): number | string => {
    if (typeof value === 'number') {
      return isPercentage ? `${Math.abs(value)}%` : Math.abs(value);
    }
    return '-';
  }, []);
  if (!values) return null;
  const combinedClassName = [styles.tableRowContainer, className].filter(Boolean).join(' ');
  return (
    <div className={combinedClassName}>
      <div className="flex flex-col">
        <span className="block--label">Last Price</span>
        <span>{values?.lastTradePrice ?? '-'}</span>
        {values?.lastTradePrice && (
          <span className="last-price-date">
            {values?.lastTradeTime && format(values.lastTradeTime, 'MMM dd, yyyy')}
          </span>
        )}
      </div>
      <div className="flex flex-col">
        <span className="block--label">Change</span>
        <div className="flex flex-col gap-1">
          <span>{values?.change ? formatNumber(values.change) : '-'}</span>
          {typeof values?.change == 'number' && (
            <span className={`price-in-percentage ${values.change < 0 ? 'price-down' : 'price-up'}`}>
              {formatNumber(values.changePercent, true)}
            </span>
          )}
        </div>
      </div>
      <div className="last-columns">
        <div>
          <span className="block--label">Bid</span>
          <span>{values?.bidPrice ?? '-'}</span>
        </div>
        <div>
          <span className="block--label">Ask</span>
          <span>{values?.askPrice ?? '-'}</span>
        </div>

        <div>
          <span className="block--label">volume</span>
          <span>{values?.volume ?? '-'}</span>
        </div>

        <div>
          <span className="block--label">Intrest</span>
          <span>{values?.openInterest ?? '-'}</span>
        </div>
      </div>
    </div>
  );
};

export default TableRow;
